var _dec, _class;
import { mixins, Options } from 'vue-class-component';
import { OrderListViewModel } from '@/views-cms/account/order-list/OrderListViewModel';
import Pagination from '../../../component/pagination/Pagination.vue';
let OrderList = (_dec = Options({
  components: {
    Pagination
  }
}), _dec(_class = class OrderList extends mixins(OrderListViewModel) {}) || _class);
export { OrderList as default };